<template>
    <div>
        <v-dialog
            v-model="dialog"
            color="#323A46"
            persistent
            :width="$vuetify.breakpoint.xs ? '90%' : '70%'"
            content-class="border-radius-2 pt-0"
            overlay-color="#7764CA"
            overlay-opacity="1"
            >
            <div class="onboarding-logo-wrapper">
                <v-img 
                    :src="logo"
                    width="100"
                    class="mx-auto">
                </v-img>
            </div>
            <v-row class="progress-bar-wrapper ma-0">
                <v-col cols="12" class="position-relative">
                    <v-progress-linear
                        background-color="#514585"
                        color="#C4BBE7"
                        v-model="completedTasksPercentage"
                        height="18"
                        class="pointer-events-none border-progress-bar"
                        rounded
                    >
                    <strong>Paso {{ currentPage }} de {{ totalPages - 1 }}</strong>
                    </v-progress-linear>
                    <v-img
                        :src="require('@/assets/img/icons/check-stroke.png')"
                        height="48"
                        width="48"
                        class="check-icon"
                    ></v-img>
                </v-col>
            </v-row>

            <v-card class="custom-card border-radius-2 pa-4 pa-sm-10">
                <v-card-title class=" d-flex justify-center px-15 mb-sm-6 position-relative">
                    <v-card-title>
                        <v-img
                            :src="require(`@/assets/img/icons/icon-voice-assistant.svg`)"
                            max-height="40px"
                            max-width="40px"
                            :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                            :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                            contain
                            class="main-sound-img-abs cursor-pointer"
                            @click="greet"
                        ></v-img>
                        <p
                            class="main-title d-flex justify-center"
                            v-html="greetWelcomeMessage"
                            >
                        </p>
                    </v-card-title>
                </v-card-title>
                <v-card-subtitle class="pb-0">
                    <p class="titles font-weight-regular">{{
                        $t('initialTour.greet_text')
                    }}
                        <span class="">{{
                            $t('initialTour.greet_text_2')
                        }}</span>
                    </p>
                </v-card-subtitle>
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        data-cy="continue-button-greet-modal"
                        class="bg-gradient-primary px-15 border-radius-1 text-transform-none font-weight-bolder"
                        large
                        dark
                        @click="nextPass"
                        >
                        {{$t('initialTour.get_started')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable no-nested-ternary */

import { mapState, mapActions } from 'vuex'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data: () => ({
        currentPage: 1,
        totalPages: 4,
        logo: require('@/assets/img/brand/logo.svg'),
        audio: null
    }),
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            avatar: (state) => state.userData.avatarSelected,
            selectedCategories: (state) => state.userData.selectedCategories,
            survey: (state) => state.userData.survey,
            course: (state) => state.userData.user.course,
            testDiagnostic: (state) => state.dashboard.testDiagnostic,
        }),
        greetWelcomeMessage() {
            const genre =
                this.$i18n.locale === 'es' ? (this.user.genre === 'FEMALE' ? 'a' : 'o') : ''
            return `${this.$t('initialTour.greet_wellcome', {
                genre,
            })}, ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
        completedTasksPercentage() {
            if (this.currentPage && this.totalPages) {
                return Math.round((this.currentPage / this.totalPages) * 100);
            } else {
                return 0;
            }
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'showFirtsPass',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
            'showDiagnosticTutorialModal',
        ]),
        nextPass() {
            this.showFirtsPass()
            if (!this.avatar || !this.selectedCategories.length) {
                this.showAvatars()
                return
            }
            const isPregrade = ['G0'].some(g => this.grade === g);
            if (!isPregrade && this.testDiagnostic && this.testDiagnostic.length) {
                this.showFinishPreferencesModal()
            }
        },
        greet(){
            this.play('greet_welcome')
        },
        play(text) {
            if (this.audio && !this.audio.paused) {
                this.audio.pause()
            }
            const audio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}onboarding/${text}.mp3`);
            audio.play()
                .then(() => {
                    this.audio = audio;
                })
                .catch(() => {
                    this.audio = null;
                });
        },
    },
    mixins: [initialReaderValidation]
}
</script>
<style lang="scss">
.main-title{
    font-size: 1.5em;
    word-break: keep-all;
    @media screen and (min-width: 600px) {
        font-size: 1rem;
    }
}
.titles{
    font-size: 1rem;
    line-height: 1.4rem;
    color: #323A46;
    text-align: center;
    span{
        color: #7764CA;
    }
}
.onboarding-sound-img{
    background: white;
    border-radius: .3em;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    @media screen and (min-width: 600px) {
        border-radius: .5em;
        top: 1rem;
        left: 1rem;
    }
}
.progress-bar-wrapper{
    position: fixed;
    top: 12vh;
    left: 5%;
    width: 90%;
    .border-progress-bar{
        box-shadow: 0px 0px 0px 8px #A295DA33;
    }
    @media screen and (min-width: 600px) {
        top: 10vh;
        left: 15%;
        width: 70%;        
    }
    .v-progress-linear .v-progress-linear__content {
        color: #FFF;
    }
}
.check-icon{
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.onboarding-logo-wrapper{
    position: fixed;
    top: -20px;
    left: 50%;
    width: 15rem;
    height: 10rem;
    background-color: white;
    border-radius: 0 0 10rem 10rem;
    transform: translate(-50%, -50%);
    z-index: 1;
    .v-image{
        width: 100px;
        display: block;
        position: fixed;
        top: 110px;
        z-index: 99999;
        left: 70px;
    }
}
</style>
